import { formatDateTimeShort, formatTime, isSameDay } from '~/utils/date'

const formatDay = (date: Date) =>
  `${`${date.getDate()}`.padStart(2, '0')}/${`${date.getMonth() + 1}`.padStart(2, '0')}/${date.getFullYear()}`

/** `scheduled` is the gendered "Prévu" / "Prévue" of the task (see `getTaskWording`). */
export const formatTaskSchedule = (
  start: Date,
  end: Date | null,
  scheduled: string
): string => {
  if (end === null || end.getTime() === start.getTime()) {
    return `${scheduled} le ${formatDateTimeShort(start)}`
  }
  if (isSameDay(start, end)) {
    return `${scheduled} le ${formatDay(start)} de ${formatTime(start)} à ${formatTime(end)}`
  }
  return `${scheduled} du ${formatDateTimeShort(start)} au ${formatDateTimeShort(end)}`
}
